import { Controller } from "@hotwired/stimulus"

// The "put it on your home screen" card (mobiel-installeerbaar/02). The server
// already picked the iPhone or the Android steps; this decides whether the card
// shows at all, which only the browser knows: started from the home screen,
// closed before on this device, or asked for again from Account.
//
// The key carries the user id, so closing it on a shared phone doesn't close it
// for the next person who signs in there.
export default class extends Controller {
  static targets = ["installButton"]
  static values = { storageKey: String, force: Boolean }

  connect() {
    if (this.standalone()) return

    if (this.forceValue) {
      this.forget()
    } else if (this.dismissed()) {
      return
    }

    this.element.hidden = false
    this.onPrompt = (event) => this.offerInstall(event)
    window.addEventListener("beforeinstallprompt", this.onPrompt)
  }

  disconnect() {
    if (this.onPrompt) window.removeEventListener("beforeinstallprompt", this.onPrompt)
  }

  dismiss() {
    try { localStorage.setItem(this.storageKeyValue, "dismissed") } catch (_error) { /* blocked storage: it just shows again */ }
    this.element.hidden = true
  }

  async install() {
    if (!this.deferredPrompt) return

    this.deferredPrompt.prompt()
    const choice = await this.deferredPrompt.userChoice
    this.deferredPrompt = null
    if (choice.outcome === "accepted") this.dismiss()
  }

  // Android hands over its own install dialog; without it the written steps stay.
  offerInstall(event) {
    event.preventDefault()
    this.deferredPrompt = event
    if (this.hasInstallButtonTarget) this.installButtonTarget.hidden = false
  }

  standalone() {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true
  }

  dismissed() {
    try { return localStorage.getItem(this.storageKeyValue) === "dismissed" } catch (_error) { return false }
  }

  forget() {
    try { localStorage.removeItem(this.storageKeyValue) } catch (_error) { /* nothing to forget */ }
  }
}
